{
  "loading": "Učitavam...",
  "placeholder": "Odaberite opciju"
}